const path = "fixit/answers/how_has_my_day_been_answers/";

export const HowHasMyDayBeenAnswers = [
  {titleKey: "fixit_answers_how_has_my_day_been_good"       , icon: path+"good_{r}x.svg"           , isSelectable: true   },
  {titleKey: "fixit_answers_how_has_my_day_been_bad"        , icon: path+"bad_{r}x.svg"            , isSelectable: true   },
  {titleKey: "fixit_answers_how_has_my_day_been_so_so"      , icon: path+"so_so_{r}x.svg"          , isSelectable: true   },
  {titleKey: "fixit_answers_how_has_my_day_been_dont_know"  , icon: path+"i_dont_know_{r}{g}.svg"  , isSelectable: true   }
];

export default HowHasMyDayBeenAnswers;